import { Box, type BoxProps, styled } from '@mui/material';

export type TitleContainerProps = Omit<BoxProps, 'children'>;

export const TitleContainer = styled(Box)({
  height: 76,
  width: 'calc(100% - 60px)',
  margin: 'auto',
  paddingTop: 16,
  paddingBottom: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: 18,
  fontWeight: 500,
  color: '#202227',
  borderBottom: '1px solid #B1B8BF',
});
